module.exports = __webpack_public_path__ + "media/images/icons/star-d95ef240af7eac8ac2dbc711b02560ee.svg";